var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48542 13.5564C8.48542 14.4473 7.40828 14.8935 6.77831 14.2635L0.707233 8.19247C0.316708 7.80195 0.316708 7.16878 0.707232 6.77826L6.7783 0.707192C7.40826 0.0772271 8.48541 0.523393 8.48541 1.4143L8.48542 13.5564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerLeft);
export default __webpack_public_path__ + "static/media/pointerLeft.a6700b66cb9bbaa64d134f46a0223536.svg";
export { ForwardRef as ReactComponent };